import React from 'react'
import _ from 'lodash'
import axios from 'axios'
import immutable from 'immutable'

import {LunaLoader} from '../widgets/lunaloader/lunaloader.component'

import {LunaMapBox} from '../widgets/lunamapbox.component'
import {ImageGrid} from '../widgets/imagegrid.component'
import {ItemTitleBlock} from '../widgets/layout/itemtitleblock.component'
import {ItemOverviewBlock} from '../widgets/layout/itemoverviewblock.component'
import {ItemReservationBlock} from '../widgets/layout/itemreservationblock.component'
import {RelatedContentBand} from '../widgets/relatedcontentband/relatedcontentband.component'


const HOTEL_URL = '/api/v1/hotels/'

export class AccommodationItem extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            index: 0,
            isOpen: false,
            loading: true,
            hotel: null,
            activeAccommodation: this.props.activeAccommodation ? this.props.activeAccommodation : null,
            destId: this.props.leg ? this.props.leg.getIn(['destination', 'id']) : null
        }

        _.bindAll(this,
            'getHotel',
            'addToItin',
            'addRelatedToItin',
            'removeFromItin',
            'removeRelatedFromItin',
            'goBack'
        )
    }

    componentDidMount() {
        // TODO: Get id out of activeAccom instead of using object
        // TODO: always check that activeAccom exists before trying to get id
        if (this.props.activeAccommodation) {
            this.getHotel(this.props.activeAccommodation.get('id'))
        } else if (this.props.activeAccommodationId) {
            this.getHotel(this.props.activeAccommodationId)
        } else {
            console.log('ERROR: No accommodation info or id to load')
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (this.state.loading !== nextState.loading || this.state.activeAccommodation !== nextProps.activeAccommodation || this.props.leg.get('id') !== nextProps.leg.get('id')) {
            return true
        } else {
            return false
        }
    }

    componentWillReceiveProps(nextProps) {
        // if (nextProps.activeAccommodation !== this.state.hotel) {
        if (nextProps.activeAccommodation !== this.state.activeAccommodation) {
            this.setState({
                loading: true,
                hotel: null,
                activeAccommodation: nextProps.activeAccommodation
            })
            document.body.scrollTop = document.documentElement.scrollTop = 0
            if (nextProps.activeAccommodation) {
                this.getHotel(nextProps.activeAccommodation.get('id'))
            } else if (nextProps.activeAccommodationId) {
                this.getHotel(nextProps.activeAccommodationId)
            }
        }
    }

    getHotel(id) {
        if (id > -1) {
            let self = this
            let requestParams = {
                with: 'images,address'
            }
            if (this.props.lunaTrip && (this.props.lunaTrip.get('isLunaTrip') || this.props.lunaTrip.get('fromLunaTrip'))) {
                requestParams.slug = this.props.lunaTrip.getIn(['trip', 'slug']) || this.props.lunaTrip.get('fromLunaTrip')
            }
            axios.get(HOTEL_URL + id + '/', {
                params: requestParams
            }).then(function (response) {
                if (response.data !== undefined) {
                    self.setState({loading: false, hotel: immutable.fromJS(response.data)})
                } else {
                    console.log('ERROR: in componentDidMount function')
                    console.log(response)
                }
            })
        } else {
            this.setState({loading: false, hotel: this.state.activeAccommodation})
        }
    }

    goBack() {
        if (this.props.goBack) {
            this.props.goBack()
        } else {
            this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.SEARCH)
        }
    }

    addToItin() {
        if (this.props.leg.getIn(['destination', 'id']) === -1 && this.props.addToItinFromOverview) {
            this.props.addToItinFromOverview(this.state.hotel)
        } else {
            this.props.onSelectAccommodation(this.props.leg, this.state.hotel, this.props.user)
            // this.props.updateDetailSections(this.props.leg, this.props.availableDetailSections.ACCOMMODATIONS, this.props.availableDetailSubSections.OVERVIEW)
        }
    }

    addRelatedToItin(accom) {
        this.props.onSelectAccommodation(this.props.leg, accom, this.props.user)
    }

    removeRelatedFromItin(accom) {
        this.props.onRemoveAccommodation(this.props.leg, accom, this.props.user)
    }

    removeFromItin() {
        this.props.onRemoveAccommodation(this.props.leg, this.state.hotel, this.props.user)
    }

    render() {
        if (this.state.loading || !this.state.hotel) {
            return <LunaLoader style="basic" triggerFade={this.props.loading} onFadeLoader={this.onFadeLoader}/>
        } else {
            let item = immutable.fromJS(this.state.hotel)

            let allImages = item.get('images')
            if (allImages.size === 0) {
                let placePhotos = item.getIn(['accommodation_place_details', 'details', 'photos']) || item.getIn(['accommodation_place_details', 'photos']) || immutable.List()
                allImages = placePhotos.map((img, i) => immutable.fromJS({
                    filename: 'https://maps.googleapis.com/maps/api/place/photo?maxwidth=800&photoreference=' + img.get('photo_reference') + '&key=AIzaSyCvwt0NnxLgeRxHrpdd1eRRVmvXcMVylJI',
                    description: '',
                    copyright: img.get('html_attributions,'),
                    pivot: {
                        in_slideshow: true,
                        slideshow_index: i
                    }
                }))
            }

            let contact = ''
            if (item.getIn(['accommodation_place_details', 'formatted_address'])) {
                contact += '<label>Address</label><p>' + item.getIn(['accommodation_place_details', 'formatted_address']) + '</p>'
            }
            if (item.getIn(['address', 'phone'])) {
                contact += '<label>Phone Number</label><p>' + item.getIn(['address', 'phone']) + '</p>'
            }
            if (item.get('website_url')) {
                contact += '<label>Website</label><p><a href="' + item.get('website_url') + '" target="_blank">' + item.get('website_url') + '</a></p>'
            }

            // We were looking for the id in the itin, but now we do a secondary search, so need to see if we had an original item
            let myIndex = this.props.leg.get('accommodations').findIndex((accom) => {
                return accom.get('id') === this.state.activeAccommodation.get('id')
            })
            let inItin = myIndex > -1

            return (
                <div className="view-area">
                    <div className="view-left-col">
                        <a onClick={() => this.goBack()} className="btn">Go Back</a>
                    </div>
                    <div className="view-center">
                        <ItemTitleBlock item={item} leg={this.props.leg} inItin={inItin} type="accommodation" removeFromItin={this.removeFromItin} addToItin={this.addToItin}/>
                        <ImageGrid images={allImages} title={item.get('name')}/>
                        <ItemOverviewBlock label='Overview' body={item.get('overview')}/>
                        <ItemOverviewBlock label='Details' body={contact}/>
                        <ItemReservationBlock label='Reservation Details' item={this.state.activeAccommodation}/>
                        <LunaMapBox item={item}/>
                        <RelatedContentBand {...this.props} addToItin={this.addRelatedToItin} removeFromItin={this.removeRelatedFromItin} item={item} destId={this.state.destId} type="similar" model="accommodation"/>
                    </div>
                    <div className="view-right-col"/>
                </div>
            )
        }
    }
}
